/* eslint-disable */
import React, { useState, useEffect } from "react";
import * as API from "../../framework/API/api";
import { ENTITYNAME, FILEURL, TOAST_TYPES } from "../../framework/constant/constant";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { utility } from "../../framework/utility/utilityProvider";
import { Grid, GridColumn as Column, GridNoRecords } from "@progress/kendo-react-grid";
import ActionButton from "../../framework/forms/helpercomponents/buttons/ActionButton";
import RoundButton from "../../framework/forms/helpercomponents/buttons/RoundButton";
import { useTranslation } from "../../locale/useTranslation";
import moment from "moment";
import ToastNotification from "../../components/ToastNotification";
import { PROMOTIONS_PLATFORM } from "./SocialMediaConstant";
import { DateOnlyCell } from "../../framework/forms/helpercomponents/CustomGridCells/DateCell";
import MetaInsightsForm from "./MetaInsightsForm";
import { MenuCommandCell } from "../../framework/forms/helpercomponents/CustomGridCells/MenuCommandCell ";

export const SMPromotionRevenueReport = () => {

    const defaultDates = utility.getFirstAndLastDateOfMonth();

    const blankDataItem = {
        fromDate: defaultDates.FirstDate,
        toDate: defaultDates.LastDate,
        platform: { _id: null, Description: 'All' },
        agency: { _id: null, Name: "All" },
        client: { _id: null, Name: "All" },
    };

    const lang = useTranslation();
    const [dataItem, setDataItem] = useState(blankDataItem);
    const [gridData, setGridData] = useState([]);
    const [platforms, setPlatforms] = useState([]);
    const [agencies, setAgencies] = useState([]);
    const [clients, setClients] = useState([]);
    const [loadingStatus, setLoadingStatus] = useState(lang.no_record_found_error_message);
    const [showInsightPopup, setShowInsightPopup] = useState({ show: false, item: null });

    useEffect(() => {
        loadcombo();
    }, []);

    const loadcombo = async () => {
        const platformRes = Object.keys(PROMOTIONS_PLATFORM).map((key) => ({
            _id: PROMOTIONS_PLATFORM[key],
            Description: key
        }));
        platformRes.unshift({ _id: null, Description: "All" });
        setPlatforms(platformRes);

        let agencyRes = await API.getDataLookup(ENTITYNAME.Agency, { sort: { Name: 1 } });
        agencyRes.data.unshift({ _id: null, Name: "All" });
        setAgencies(agencyRes.data);

        let clientRes = await API.getDataLookup(ENTITYNAME.Client, { sort: { Name: 1 } });
        clientRes.data.unshift({ _id: null, Name: "All" });
        setClients(clientRes.data);
    };

    const onChange = (e) => {
        setDataItem({ ...dataItem, [e.target.name]: e.target.value })
    };

    const isValid = () => {
        if (dataItem.fromDate == undefined || dataItem.fromDate == "") {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_from_date_error_message });
            return false;
        }
        if (dataItem.toDate == undefined || dataItem.toDate == "") {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_to_date_error_message });
            return false;
        }
        if (dataItem.toDate < dataItem.fromDate) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_to_date_grater_then_from_date_error_message });
            return false;
        }
        return true;
    };

    const loadData = async () => {

        if (!isValid()) return;

        setLoadingStatus(lang.data_loading_error_message);

        let payload = {
            fromDate: dataItem?.fromDate ? utility.convertStringDatetoMilliseconds(dataItem?.fromDate) : null,
            toDate: dataItem?.toDate ? utility.convertStringDatetoMilliseconds(dataItem?.toDate) : null,
            platform: dataItem.platform?._id ?? null,
            agency: dataItem.agency?._id ?? null,
            client: dataItem.client?._id ?? null,
            isExport: false
        };

        const res = await API.exportPromotionRevenueReport(payload);
        console.log(res);
        if (res && res.success) {
            if (res.data && res.data.length > 0) {
                setGridData(res.data);
            } else {
                setGridData([]);
                setLoadingStatus(lang.no_record_found_error_message);
            }
        } else {
            setLoadingStatus(lang.no_record_found_error_message);
        }
    };

    const downloadExcel = async () => {
        if (gridData.length === 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.no_record_found_error_message });
            return;
        }

        const payload = {
            fromDate: dataItem?.fromDate ? utility.convertStringDatetoMilliseconds(dataItem?.fromDate) : null,
            toDate: dataItem?.toDate ? utility.convertStringDatetoMilliseconds(dataItem?.toDate) : null,
            platform: dataItem.platform?._id ?? null,
            agency: dataItem.agency?._id ?? null,
            client: dataItem.client?._id ?? null,
            isExport: true
        };

        const res = await API.exportPromotionRevenueReport(payload);

        if (res && res.success) {
            window.open(FILEURL().BASEURL + 'downloadReport/' + res.data);
            ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: lang.successfully_download_success_message });
        } else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res?.message || lang.report_is_not_exported_error_message });
        }
    };

    const insightMenuModel = (props) => {
        const attachedPost = props?.dataItem?.AttachedPosts;
        const items = [];

        if (!attachedPost) { return []; }

        if (attachedPost.isPublished === true) {
            items.push({
                label: lang.insight_label, icon: "pi pi-chart-bar",
                command: () => { setShowInsightPopup({ show: true, item: props.dataItem, savedInsights: null }); }
            });
        } else {
            items.push({
                label: lang.last_insight_label, icon: "pi pi-chart-bar",
                command: () => {
                    const historyList = attachedPost?.history?.length > 0 ? attachedPost?.history : [];
                    const lastInsight = [...historyList].reverse().find(h => h?.insights && Object.keys(h.insights).length > 0);
                    if (lastInsight) {
                        setShowInsightPopup({ show: true, item: props.dataItem, savedInsights: lastInsight.insights });
                    } else {
                        ToastNotification({ type: TOAST_TYPES.WARNING, title: lang.warning_label, message: lang.this_post_is_not_publish_insight_not_available_warning_message });
                    }
                }
            });
        }
        return [{ label: lang.options_label, items }];
    };

    const MyCommandCell = (props) => (
        <MenuCommandCell
            {...props}
            myMenuModel={insightMenuModel}
        />
    );

    return (<>
        <h1 className="page-title txt-color-bludeDark">
            <i
                className="fa fa-table marlr"
                style={{ fontSize: "20px", color: "GrayText" }}
            ></i>
            <span>{lang.sm_revenue_report_header}</span>
        </h1>
        <div className="row m-1">
            <div className="col-12">
                <div className="card p-3" style={{marginTop: "-20px"}}>
                    <div className="row mb-1">
                        <div className="col-12 d-flex">
                            <ActionButton icon="download" title={lang.export_button_tooltip} name={lang.export_button_text} onClick={downloadExcel} style={{ marginLeft: "1px" }} />
                            <ActionButton name={lang.show_button_text} onClick={loadData} style={{ marginLeft: "10px" }} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-2">
                            <label className="form-label">{lang.platform_label}</label>
                            <DropDownList
                                data={platforms}
                                textField="Description"
                                dataItemKey="_id"
                                name="platform"
                                onChange={onChange}
                                value={dataItem.platform}
                            />
                        </div>
                        <div className="col-md-2">
                            <label className="form-label">{lang.agency_label}</label>
                            <DropDownList
                                data={agencies}
                                textField="Name"
                                dataItemKey="_id"
                                name="agency"
                                onChange={onChange}
                                value={dataItem.agency}
                            />
                        </div>
                        <div className="col-md-2">
                            <label className="form-label">{lang.client_label}</label>
                            <DropDownList
                                data={clients}
                                textField="Name"
                                dataItemKey="_id"
                                name="client"
                                onChange={onChange}
                                value={dataItem.client}
                            />
                        </div>
                        <div className="col-md-3">
                            <label className="form-label">{lang.from_date_label} *</label>
                            <input
                                type="date"
                                className="form-control form-control-sm"
                                name="fromDate"
                                value={dataItem.fromDate}
                                onChange={onChange}
                            />
                        </div>
                        <div className="col-md-3">
                            <label className="form-label">{lang.to_date_label} *</label>
                            <input
                                type="date"
                                className="form-control form-control-sm"
                                name="toDate"
                                value={dataItem.toDate}
                                onChange={onChange}
                            />
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <Grid data={gridData} style={{ height: '60vh' }} resizable={true}>
                            <GridNoRecords>{loadingStatus}</GridNoRecords>
                            <Column editable={false} cell={MyCommandCell} width={"60px"} />
                            <Column field="CampaignTitle" title={lang.campaing_title_column} />
                            <Column field="PostTitle" title={lang.post_title_column} />
                            <Column field="PostStartDate" title={lang.post_start_date_column} cell={DateOnlyCell} />
                            <Column field="PostEndDate" title={lang.post_end_date_column} cell={DateOnlyCell} />
                            <Column field="PostAmount" title={lang.amount_column} />
                        </Grid>
                    </div>
                </div>
            </div>
        </div>
        {showInsightPopup.show && (
            <MetaInsightsForm
                item={showInsightPopup.item?.AttachedPosts}
                pageId={showInsightPopup.item?.PublishPage?._id || showInsightPopup.item?.PublishPage}
                platform={showInsightPopup.item?.PromotionsPlatform?._id || showInsightPopup.item?.PromotionsPlatform}
                savedInsights={showInsightPopup.savedInsights}
                onClose={() => setShowInsightPopup({ show: false, item: null, savedInsights: null })
                }
            />
        )}
    </>)
}
export default SMPromotionRevenueReport;
